import { b64decode, b64encode } from "../../b64";

export class B64ValueConverter {
    toView(value, format) {
        if (format === 'decode') {
            return b64decode(value);
        }
        return b64encode(value);
    }
}
